module.exports = __webpack_public_path__ + "img/no_user.68c31867.svg";